module.exports = __webpack_public_path__ + "static/1-0653079aba3488ed7133ae8d7480bf69.png";